import template from './sellops-settings.html.twig';

const { Component, Mixin } = Shopware;

const DEFAULT_GUARD = {
    min:   0,
    label: 'This field',
};

Component.register('sellops-settings', {
    template,

    inject: ['loginService', 'sellopsUpsellApiService'],

    mixins: [Mixin.getByName('notification')],

    data() {
        return {
            isLoading: false,
            isSaveSuccessful: false,
            _guardObserver: null,
            supportedMethods:       [],
            supportedMethodsNote:   '',
            supportedMethodsLoaded: false,
        };
    },

    mounted() {
        this.$nextTick(() => {
            this.applyNumericGuards();
            this._guardObserver = new MutationObserver(() => this.applyNumericGuards());
            this._guardObserver.observe(this.$el, { childList: true, subtree: true });
        });

        this.loadSupportedMethodsInfo();
    },

    beforeDestroy() {
        this._guardObserver?.disconnect();
        this._guardObserver = null;
    },

    beforeUnmount() {
        this._guardObserver?.disconnect();
        this._guardObserver = null;
    },

    methods: {
        onLoadingChanged(loading) {
            this.isLoading = loading;
            if (!loading) {
                this.$nextTick(() => this.applyNumericGuards());
            }
        },

        applyNumericGuards() {
            const root = (this.$el && this.$el.querySelectorAll && this.$el.querySelector('input'))
                ? this.$el
                : document.querySelector('.sellops-settings-page');

            if (!root || !root.querySelectorAll) return;

            const selectors = [
                'input[type="number"]',
                'input[inputmode="numeric"]',
                '.sw-field--number input',
                '.sw-number-field input',
                '.mt-number-field input',
            ];
            const candidates = root.querySelectorAll(selectors.join(', '));

            if (!this._firstCallLogged) {
                this._firstCallLogged = true;
            }

            candidates.forEach((input) => {
                if (input.dataset.spGuardBound === '1') return;
                input.dataset.spGuardBound = '1';

                const opts = {
                    ...DEFAULT_GUARD,
                    label: this._findFieldLabel(input) || DEFAULT_GUARD.label,
                };

                input.setAttribute('min',       String(opts.min));
                input.setAttribute('step',      '1');
                input.setAttribute('inputmode', 'numeric');
                input.setAttribute('pattern',   '\\d*');

                const onInput = (ev) => this._onGuardedInput(ev, opts);
                input.addEventListener('input',  onInput);
                input.addEventListener('change', onInput);
            });

        },

        _findFieldLabel(input) {
            const wrapper = input.closest(
                '.sw-form-field-renderer, [class*="sw-system-config__field"], .sw-field',
            );
            const label = wrapper?.querySelector('label');
            return label ? label.textContent.trim() : null;
        },

        _onGuardedInput(ev, opts) {
            const input    = ev.target;
            const original = String(input.value ?? '');

            if (original === '') return;

            const parsed = parseInt(original, 10);
            if (Number.isNaN(parsed)) return;

            let cleanedNum       = parsed;
            let clampedFromBelow = false;
            if (cleanedNum < opts.min) {
                cleanedNum       = opts.min;
                clampedFromBelow = true;
            }

            const cleaned = String(cleanedNum);
            if (cleaned === original) return; // nothing to do

            input.value = cleaned;
            input.dispatchEvent(new Event('input', { bubbles: true }));

            const triedNegative = original.includes('-');
            if (triedNegative || clampedFromBelow) {
                this.createNotificationError({
                    title:   'Invalid value',
                    message: `"${opts.label}" must be a whole number ${opts.min} or greater. Adjusted to ${cleaned}.`,
                });
            }
        },

        onSave() {
            this.isSaveSuccessful = false;
            this.isLoading = true;

            this.$refs.systemConfig.saveAll().then(() => {
                this.isLoading = false;
                this.isSaveSuccessful = true;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onSaveFinish() {
            this.isSaveSuccessful = false;
        },

        async loadSupportedMethodsInfo() {
            try {
                const data = await this.sellopsUpsellApiService.getSupportedPaymentMethods() ?? {};
                this.supportedMethods     = Array.isArray(data.methods) ? data.methods : [];
                this.supportedMethodsNote = typeof data.note === 'string' ? data.note : '';
            } catch{
                this.supportedMethods     = [];
                this.supportedMethodsNote = '';
            } finally {
                this.supportedMethodsLoaded = true;
            }
        },
    },
});
